import { render, staticRenderFns } from "./SelectorMultiple.vue?vue&type=template&id=6f680a3f&scoped=true&"
import script from "./SelectorMultiple.vue?vue&type=script&lang=js&"
export * from "./SelectorMultiple.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f680a3f",
  null
  
)

export default component.exports